module.exports = __webpack_public_path__ + "img/gj-bg.0ba19f9f.png";